import { render, staticRenderFns } from "./LinkedDocuments.vue?vue&type=template&id=2b1b6087"
import script from "./LinkedDocuments.vue?vue&type=script&lang=js"
export * from "./LinkedDocuments.vue?vue&type=script&lang=js"
import style0 from "./LinkedDocuments.vue?vue&type=style&index=0&id=2b1b6087&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports